import React from 'react';
import { HelpModalContentBody } from '@Components/HelpModal/HelpModal.style';
import { textblocks } from 'seal-ui-components';
import { AskQuestionIcon, ListIcon, InsertIcon } from '@Components/UI/Icons';
import { icons } from 'seal-ui-components';

const ScorecardsHelpModalContent = () => (
    <HelpModalContentBody>
        <textblocks.Heading3>The Scorecard</textblocks.Heading3>
        <p>
            The Scorecard helps you get a better overview on the risk level each Subtopic poses. A
            Scorecard is generated by selecting an appropriate Scorecard and click Analyze.
        </p>

        <textblocks.Heading3>Filter and Sorting</textblocks.Heading3>
        <p>
            To filter your Scorecard by specific Risk Levels, Topics, Subtopics, and more, select
            the arrow at the top of the screen and expand the Filter area. Here, you can input
            specific terms and tags, or choose to sort by multiple criteria. The items visible in
            the Scorecard will change depending on your filtering choices.
        </p>

        <textblocks.Heading3>Inspecting a Scorecard</textblocks.Heading3>
        <p>
            A Scorecard shows you the identified Risk level for each Subtopic, grouped and sorted by
            Topics. The <AskQuestionIcon /> icon will display the full question for the Subtopic,
            and hovering over <icons.InfoSmallIcon /> will give you more information about how this
            result was calculated. Clicking the Scorecard will expand it and allow you to step
            through the extracted language, if any.
        </p>

        <textblocks.Heading3>Insert Clause</textblocks.Heading3>
        <p>
            If there is a Clause linked to the Scorecard you can view the Description and a preview
            of the full text from the Scorecard panel by clicking <ListIcon /> . Clicking{' '}
            <InsertIcon /> will insert the full language text into the document, replacing any
            language that is currently highlighted. The Clause Library can be reached from this
            page.
        </p>
    </HelpModalContentBody>
);

export default ScorecardsHelpModalContent;
